export default __webpack_public_path__ + "static/media/login-image.4c72022b.png";